import { Hr } from '@euler/app/components/Hr';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { Dropdown, DropdownOption } from '@euler/components/dropdown';
import { FormGroup } from '@euler/components/form';
import { useOrderTags } from '@euler/functions/useOrderTags';
import { memo, useCallback, useMemo } from 'react';

export const OrderTagsField = memo(() => {
  const { form } = useOrderSearchForm();

  const tags = useOrderTags();
  const options = useMemo(
    () =>
      tags.map<DropdownOption<string>>(tag => ({
        label: tag.name,
        value: tag.name,
      })),
    [tags],
  );

  const onChange = useCallback(
    (values: string[] | undefined) => {
      form.tags.update(values);
    },
    [form.tags],
  );

  return (
    <FormGroup label="业务类型">
      <Dropdown
        mode="multiple"
        options={options}
        value={form.tags.value}
        clearable={true}
        placeholder="按业务类型搜索"
        onChange={onChange as any}
        withTagsView={true}
        tagRemovable={true}
        ItemSeparatorComponent={() => <Hr color="#ddd" />}
      />
    </FormGroup>
  );
});
